import Modal from 'flarum/common/components/Modal';
/**
 * A finding's notes on the public /expo/:id page (ExpoPage's "i" button):
 * the text its société wrote with it (ExhibitionFindingEditModal's
 * "Notes"), its own lines kept - plain text, never HTML.
 */
export default class FindingNoteModal extends Modal {
  className() {
    return 'Modal--small ChampisFindingNoteModal';
  }
  title() {
    return [this.attrs.finding.label(), this.attrs.name].filter(Boolean).join(' · ');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "ChampisFindingNoteModal-text"
    }, this.attrs.finding.notes()));
  }
}
flarum.reg.add('champis-exhibitions', 'forum/components/FindingNoteModal', FindingNoteModal);